import { render, staticRenderFns } from "./Italic.vue?vue&type=template&id=2399cb1a&scoped=true&"
import script from "./Italic.vue?vue&type=script&lang=js&"
export * from "./Italic.vue?vue&type=script&lang=js&"
import style0 from "./Italic.vue?vue&type=style&index=0&id=2399cb1a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399cb1a",
  null
  
)

export default component.exports